import { useMemo } from "react";
import { CroppingPatternReportModel } from "@agroyaar/sdk";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import LineChart from "@/shared/components/charts/LineChart";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";

interface IrrigationRequirementProps {
  croppingPatternReports: CroppingPatternReportModel[];
  chartYears: string[];
  pageNumber: number;
}

const IrrigationRequirement = ({
  croppingPatternReports,
  chartYears,
  pageNumber,
}: IrrigationRequirementProps) => {
  const series = useMemo(
    () =>
      croppingPatternReports.map(
        ({ annuallyNetIrrigationRequirement, crop }) => ({
          name: crop.persianName,
          data: annuallyNetIrrigationRequirement.map(({ value }) => value),
        })
      ),
    [croppingPatternReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={pageNumber}>
      <div className="w-full flex flex-col gap-6">
        <Title>نیاز خالص آبیاری 30 سال گذشته</Title>
        <div className="w-full flex flex-col justify-center items-center gap-3 my-8">
          <LineChart
            xAxisTitle="سال"
            yAxisTitle="نیاز خالص آبیاری (مترمربع در هکتار)"
            xAxisLabelsOptionsStep={1}
            labelsFontSize="10px"
            categories={chartYears}
            series={series}
          />
          <Title>
            مقدار نیاز خالص آبیاری برای رسیدن به پتانسیل عملکرد در 30 سال گذشته
          </Title>
        </div>
      </div>

      <NoteBox>
        نیاز خالص آبیاری محصول برای دستیابی به پتانسیل عملکرد در منطقه تخمین زده
        شده است. در نظر داشته باشید که در صورت بهبود راندمان سیستم آبیاری، میزان
        تلفات و نیاز خالص آبیاری کاهش خواهد یافت.
      </NoteBox>
    </ReportTemplate>
  );
};

export default IrrigationRequirement;
